import React from "react";

// material ui
import {
  FormControl,
  Input,
  FormHelperText,
  InputLabel,
} from "@material-ui/core";

// style
import styles from "./Form.module.scss";

const TextAreaForm = ({
  name = null,
  label = "default",
  handleChange = null,
  value = "",
  placeholder = "default",
  helperText = "default",
  disabled = "false",
}) => {
  return (
    <FormControl fullWidth className={styles["form-control"]}>
      <InputLabel
        className={styles["form-label"]}
        shrink={true}
        disableAnimation={true}
        htmlFor={`${name}-helper`}
      >
        {label}
      </InputLabel>
      <Input
        className={styles["form-input"]}
        id={`${name}-helper`}
        value={value}
        onChange={(e) => {
          handleChange(e);
        }}
        aria-describedby={`${name}-helper-text`}
        placeholder={placeholder}
        multiline={true}
        rows={7}
        rowsMax={7}
        disabled={disabled}
      />
      {helperText.length !== 0 && (
        <FormHelperText id={`${name}-helper-text`}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default TextAreaForm;
